export default "__VITE_ASSET__BEe$$Cvf__"